import React from 'react';
import '../../styles/sections.css';
import '../../styles/requirements.css';

const Requirements = () => (
  <div className="requirements-section">
    <div className="section-header">
      <h2>REQUIREMENTS</h2>
      <div className="underline"></div>
    </div>
    <div className="requirements-content">
      <h3>Functional</h3>
      <ul>
        <li>Player movement & physics system</li>
        <li>Obstacle collision & response</li>
        <li>Dynamic level progression</li>
        <li>Multiplayer sync & networking</li>
        <li>Score tracking & leaderboards</li>
        <li>Power-up collection & usage</li>
        <li>Game state management & saves</li>
        <li>User authentication & profiles</li>
      </ul>

      <h3>Non-Functional</h3>
      <ul>
        <li>Responsive, low-latency controls</li>
        <li>Stable 60 FPS across devices</li>
        <li>Scalable server architecture</li>
        <li>Cross-platform support (PC, mobile, console)</li>
        <li>Cloud saves & data persistence</li>
        <li>Anti-cheat & fair play systems</li>
        <li>Accessibility options</li>
      </ul>

      <h3>User Experience</h3>
      <ul>
        <li>Intuitive, responsive UI</li>
        <li>Clear visual feedback</li>
        <li>Progressive difficulty curve</li>
        <li>Engaging rewards & achievements</li>
        <li>Social features & community tools</li>
        <li>Regular updates & seasonal events</li>
      </ul>
    </div>
  </div>
);

export default Requirements;
